import styles from './nav-item.module.css';

import { Button, Card, Text } from '@radix-ui/themes';
import React from 'react';
import Link from 'next/link';
import { ColorType } from '@/app/lib/schemas/types/app-types';

interface MyButtonProps {
  children: React.ReactNode; // Используем children вместо label
  color: ColorType;
  onClick?: () => void;
}

const NavButton = React.forwardRef<HTMLButtonElement, MyButtonProps>(
  ({ children, onClick, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        onClick={onClick}
        asChild
        {...props}
      >
        <Card
          className={styles.MenuItem}
          size='1'
        >
          <Text align='center'>{children}</Text>
        </Card>
      </Button>
    );
  }
);

NavButton.displayName = 'NavButton'; // Нужно для отладки в DevTools

interface Props {
  href: string;
  isActive: boolean;
  onBeforeNavigate: () => void;
  label: string;
}

export default function NavItem({
  href,
  label,
  isActive,
  onBeforeNavigate
}: Props) {
  return (
    <Link
      href={href}
      passHref
      className={styles.Anchor}
    >
      <NavButton
        color={isActive ? 'jade' : 'gray'}
        onClick={() => onBeforeNavigate()}
      >
        {label}
      </NavButton>
    </Link>
  );
}
